"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeIncomingOppositeMoves = exports.getFirst = exports.scopeValue = exports.getInitialState = exports.getRandomPixel = exports.getRandomValue = exports.isMoveOpposite = exports.inputToMove = void 0;
var ramda_1 = require("ramda");
var constants_1 = require("./constants");
function inputToMove(input) {
    return constants_1.MOVES[input];
}
exports.inputToMove = inputToMove;
exports.isMoveOpposite = function (move) { return function (moveToCheck) {
    switch (move) {
        case constants_1.MOVES['UP']:
            return ramda_1.equals(moveToCheck, constants_1.MOVES['DOWN']);
        case constants_1.MOVES['DOWN']:
            return ramda_1.equals(moveToCheck, constants_1.MOVES['UP']);
        case constants_1.MOVES['LEFT']:
            return ramda_1.equals(moveToCheck, constants_1.MOVES['RIGHT']);
        case constants_1.MOVES['RIGHT']:
            return ramda_1.equals(moveToCheck, constants_1.MOVES['LEFT']);
        default:
            return false;
    }
}; };
function getRandomValue(min, max) {
    return Math.floor(Math.random() * max) + min;
}
exports.getRandomValue = getRandomValue;
function getRandomPixel(frameDimensions) {
    return {
        x: getRandomValue(0, frameDimensions.cols - 1),
        y: getRandomValue(0, frameDimensions.rows - 1),
    };
}
exports.getRandomPixel = getRandomPixel;
function getInitialState(frameDimensions) {
    return {
        frame: {
            hasSnakeCrashed: false,
            snake: [getRandomPixel(frameDimensions)],
            apple: getRandomPixel(frameDimensions),
            dimensions: frameDimensions,
            score: 0,
        },
        moves: [constants_1.MOVES['STOPPED']],
    };
}
exports.getInitialState = getInitialState;
exports.scopeValue = function (min, max) { return function (value) {
    return ramda_1.cond([
        [ramda_1.gt(ramda_1.__, max), ramda_1.always(min)],
        [ramda_1.lt(ramda_1.__, min), ramda_1.always(max)],
        [ramda_1.T, ramda_1.identity],
    ])(value);
}; };
exports.getFirst = function (_a) {
    var firstItem = _a[0];
    return firstItem;
};
exports.removeIncomingOppositeMoves = function (currentMove) { return function (incomingMoves) {
    return ramda_1.cond([
        [ramda_1.propEq('length', 0), ramda_1.identity],
        [
            ramda_1.pipe(exports.getFirst, exports.isMoveOpposite(currentMove)),
            ramda_1.pipe(ramda_1.drop(1), exports.removeIncomingOppositeMoves(currentMove)),
        ],
        [ramda_1.T, ramda_1.identity],
    ])(incomingMoves);
}; };
